import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class TextTool extends BaseTool {
  public id: ToolType = 'text';
  public name = 'Text Tool';
  public cursor = 'text';

  public onMouseDown(_e: MouseEvent, canvasX: number, canvasY: number): void {
    const settings = this.editor.toolSettings;
    const active = this.editor.getActiveLayer();

    // Check if active layer is already a text layer and clicked near it
    if (active && active.type === 'text') {
      const promptText = window.prompt('Edit layer text:', active.textData?.text || '');
      if (promptText !== null) {
        if (active.textData) {
          active.textData.text = promptText;
        }
        active.renderText();
        this.editor.recordHistory('Edit Text');
        this.editor.render();
      }
      return;
    }

    // Otherwise create a new text layer
    const text = window.prompt('Enter text to add to canvas:', 'Your Text Here');
    if (!text) return;

    const layer = this.editor.addTextLayer(
      text,
      Math.round(canvasX),
      Math.round(canvasY),
      settings.textFontFamily,
      settings.textFontSize,
      settings.textColor
    );

    this.editor.recordHistory('Add Text Layer');
    this.editor.render();
  }
}
